module.exports = __webpack_public_path__ + "static/media/nissan-pin.3a5e3a7c.svg";